@let currentTotalRowCount = totalRowCount();
<div class="pagination">
    @if (currentTotalRowCount && currentTotalRowCount > 0) {
        <div class="sizeSelect">
            <form [formGroup]="pageSizeForm">
                <div class="inputGroup">
                    <select [formControlName]="'size'" class="formControl" (change)="onPageSizeChanged()" id="size">
                        @for (size of pageSizesList; track size) {
                            <option [value]="size">{{ size }}</option>
                        }
                    </select>
                </div>
            </form>
        </div>
    }
    <div class="paginationActions">
        <button [disabled]="currentPageNumber === 1" (click)="first()" class="button secondary small">
            <i class="fa-solid fa-fw fa-arrow-left-to-line"></i>
        </button>

        <button [disabled]="currentPageNumber === 1" (click)="previous()" class="button secondary small">
            <i class="fa-solid fa-fw fa-arrow-left"></i>
        </button>

        <div class="text">
            <span>Page </span>
            <span class="current-page">{{ currentPageNumber }}</span>
            <span> of </span>
            <span class="last-page">{{ totalPages }}</span>
        </div>

        <button [disabled]="currentPageNumber === totalPages || totalPages === 0" (click)="next()" class="button secondary small">
            <i class="fa-solid fa-fw fa-arrow-right"></i>
        </button>

        <button [disabled]="currentPageNumber === totalPages || totalPages === 0" (click)="last()" class="button secondary small">
            <i class="fa-solid fa-fw fa-arrow-right-to-line"></i>
        </button>
    </div>
    <div class="paginationRows">
        @if (currentTotalRowCount && currentTotalRowCount > 0) {
            <div class="text">
                <span class="start-row">{{ fromRow }}</span>
                <span> to </span>
                <span class="end-row">{{ toRow }}</span>
                <span> of </span>
                <span class="total">{{ currentTotalRowCount }}</span>
            </div>
        }

        @if (currentTotalRowCount && currentTotalRowCount > 0) {
            <div class="inline-block">
                <p class="start-row">{{ 'generalKeywords.noRecordsFound' | translate }}</p>
            </div>
        }
    </div>
</div>
